<template>
	<EMCoreTemplate category="Core" identity="message" entity="core_message"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		name: 'Message',
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementCore/containers/Message.vue